export const Baseurl =
  "https://cosmos.bajajfinservsecurities.in/partner-bo/api/admin";

export const partner_Admin_Url =
  "https://cosmos.bajajfinservsecurities.in/partner-admin/api";

export const partner_Side_Url =
  "https://cosmos.bajajfinservsecurities.in/partner/api";

export const cosmos_baseurl = "https://cosmos.bajajfinservsecurities.in/api/rm"


export const Partner_Reports = {
  Client_Search_Partner_URL: partner_Side_Url + "/client/partner-client-search",
  // ClientHoldingReport_Partner_URL:
  //   partner_Side_ClientDashboard_Url + "/client/ClientHoldingReport",
  // TradeSummaryReport_Partner_URL:
  //   partner_Side_ClientDashboard_Url + "/client/TradeSummaryTrade",
  // CombineLedgerReport_Partner_URL:
  //   partner_Side_ClientDashboard_Url + "/client/CombineLedgerReport",
  // DPReportTrade_Partner_URL: partner_Side_ClientDashboard_Url + "/client/DPReportTrade",
  // IntrestReportTrade_Partner_URL:
  //   partner_Side_ClientDashboard_Url + "/client/IntrestReportTrade",
  // PnlReport_Partner_URL: partner_Side_ClientDashboard_Url + "/client/PnlReport",
  // MTFDetails_Partner_URL: partner_Side_ClientDashboard_Url + "/client/MTFDetails",
  // MTFDelayPaymentReport_Partner_URL:
  //   partner_Side_ClientDashboard_Url + "/client/MTFDelayPaymentReport",
};

export const PARTNER = {
  GET_DISPOSITION: Baseurl + "/master/dispositions",
  MASTER_PARTNER: Baseurl + "/master/partner-categories",
  STATUS_DISPOSITON: Baseurl + "/partner",
  REJECT_REASONS: Baseurl + "/master/reject-reasons",
  REJECTION_UPDATED: Baseurl + "/partner/status",
  GET_PARTNER_ID: Baseurl + "/partner",
  GET_PARTNER_DETAILS: Baseurl + "/partners",
  DELETE_CLIENT_DATA: Baseurl + "/partner",
};

export const partner_Admin = {
  GetClientForm_URL: partner_Admin_Url + "/admin/client",
  GetBardChart_URL: partner_Admin_Url + "/admin/total-account-series",
  GetStatsData_URL: partner_Admin_Url + "/admin/stats",
  GetClientTable_Url: partner_Admin_Url + "/admin/partners",
  GetPartnerById: partner_Admin_Url + "/admin/partner",
  GET_PARTNER_UPLOAD_INVOICE: partner_Admin_Url + "/admin/partnerUploadInvoice",
  GET_PARTNER_INVOICE: partner_Admin_Url + "/admin/partnerInvoice",
  Get_Partner_Invoices_Url: partner_Admin_Url + "/admin/partnerInvoices",
  Get_MapClient_Url: partner_Admin_Url + "/admin/mapClient",
  Get_Demat_Lead_Tracking_Url: partner_Admin_Url + "/admin/client/leads",
  Get_Partner_Invoice_Pass_Url:
    partner_Admin_Url + "/admin/partnerCheckPassword",
  GET_COMMISSION_URL: partner_Admin_Url + "/admin/commissionFile",
  GET_APPROVED_LIST: partner_Admin_Url + "/admin/adminApprovefile",
  GET_PARTNER_SSO: partner_Admin_Url + "/admin/ssoLogin",
  GET_CLIENT_TYPE: partner_Admin_Url + "/admin/client/details/",
};

export const partner_Api = {
  GET_ACTIVE_CLIENT: partner_Side_Url + "/partner/active-clients",
  GET_ONBOARDING_DATA: partner_Side_Url + "/client/client-onboarding",
  GET_BUSINESS_SNAPSHOT: partner_Side_Url + "/client/business-snapshot",
  GET_PID_DETAILS: partner_Side_Url + "/partner",
  GET_REFERAL_LINK: partner_Side_Url + "/ext/referral",
  GET_EDIT: partner_Side_Url + "/client/client-onboarding-resume",
  GET_CLIENT_DETAILS: partner_Side_Url + "/client/client",
  GET_PORTANALYSIS: partner_Side_Url + "/client/client-portfolio",
  GET_INVESTMENT_SNAPSHOT: partner_Side_Url + "/client/investment-snapshot",

  Get_APCode: cosmos_baseurl + "/partner/getapcodes",
  Get_PartnerCode: cosmos_baseurl + "/partner/getpartnercodes",
  Get_PayoutModuleDetails: cosmos_baseurl + "/partner/getapdetails",
  Get_ParterDetails: cosmos_baseurl + "/partner/insertpartnerdetails",
  Get_PartnerTableDetails: cosmos_baseurl + "/partner/getpartnerdetails",

  Insertcommission: cosmos_baseurl + "/partner/insertcommission",
  Getcommissiondetails: cosmos_baseurl + "/partner/getcommissiondetails",
  Getpacks: cosmos_baseurl + "/partner/getpacks",
  Updatestatus: cosmos_baseurl + "/partner/updatestatus", 
  


  // Get_DownloadDocuments_Partner: partner_Side_ClientDashboard_Url + "/client/download-document",
};